import { createTheme, ITheme } from '@fluentui/react';

const fontFamily =
    "'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, " +
    "Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

export const lightTheme: ITheme = createTheme({
    palette: {
        themePrimary: '#00263B',
        themeLighterAlt: '#f2f5f7',
        themeLighter: '#d0dce2',
        themeLight: '#abc0ca',
        themeTertiary: '#5e839a',
        themeSecondary: '#225D7E',
        themeDarkAlt: '#0A3852',
        themeDark: '#001f31',
        themeDarker: '#001724',
        neutralLighterAlt: '#FAFAF7',
        neutralLighter: '#F4F4F0',
        neutralLight: '#E3EBEF',
        neutralQuaternaryAlt: '#D5DDE1',
        neutralQuaternary: '#C7D7DF',
        neutralTertiaryAlt: '#ABB8BF',
        neutralTertiary: '#8A979E',
        neutralSecondary: '#4D6876',
        neutralPrimaryAlt: '#1F4357',
        neutralPrimary: '#00263B',
        neutralDark: '#001B29',
        black: '#00121B',
        white: '#FFFFFF',
    },
    semanticColors: {
        bodyBackground: '#F4F4F0',
        bodyText: '#00263B',
        bodySubtext: 'rgba(0, 38, 59, 0.65)',
        bodyDivider: 'rgba(0, 38, 59, 0.10)',
        link: '#225D7E',
        linkHovered: '#3A7A9E',
        primaryButtonBackground: '#00263B',
        primaryButtonBackgroundHovered: '#0A3852',
        primaryButtonBackgroundPressed: '#001f31',
        primaryButtonText: '#FFFFFF',
        inputBorder: 'rgba(0, 38, 59, 0.18)',
        inputBorderHovered: '#00263B',
        inputFocusBorderAlt: '#225D7E',
    },
    defaultFontStyle: {
        fontFamily,
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
    },
    // Collabspace radii — Fluent v8 defaults are 2px and read near-square
    // next to the hand-rolled Tenants/Dashboard elements at 8px. Raising
    // `effects.roundedCorner*` brings every Fluent control (Button, SearchBox,
    // Dropdown, IconButton, TextField, DatePicker, Panel header, etc.) into
    // the same rounded language as the Collabspace primitives.
    effects: {
        roundedCorner2: '4px',
        roundedCorner4: '6px',
        roundedCorner6: '8px',
    },
});

export const darkTheme: ITheme = createTheme({
    palette: {
        themePrimary: '#7AB4D1',
        themeLighterAlt: '#050708',
        themeLighter: '#131e23',
        themeLight: '#243743',
        themeTertiary: '#476e82',
        themeSecondary: '#5E9EBD',
        themeDarkAlt: '#86bcd6',
        themeDark: '#97c5dc',
        themeDarker: '#b1d3e5',
        neutralLighterAlt: '#131B1F',
        neutralLighter: '#1A2328',
        neutralLight: '#222B31',
        neutralQuaternaryAlt: '#2A3A43',
        neutralQuaternary: '#334650',
        neutralTertiaryAlt: '#607580',
        neutralTertiary: 'rgba(232, 236, 238, 0.45)',
        neutralSecondary: 'rgba(232, 236, 238, 0.65)',
        neutralPrimaryAlt: '#D4DBDE',
        neutralPrimary: '#E8ECEE',
        neutralDark: '#F3F5F6',
        black: '#FAFBFB',
        white: '#131B1F',
    },
    semanticColors: {
        bodyBackground: '#0B1316',
        bodyText: '#E8ECEE',
        bodySubtext: 'rgba(232, 236, 238, 0.65)',
        bodyDivider: 'rgba(255, 255, 255, 0.08)',
        link: '#7AB4D1',
        linkHovered: '#5E9EBD',
        primaryButtonBackground: '#7AB4D1',
        primaryButtonBackgroundHovered: '#5E9EBD',
        primaryButtonBackgroundPressed: '#4F8AA5',
        primaryButtonText: '#00263B',
        inputBorder: 'rgba(255, 255, 255, 0.16)',
        inputBorderHovered: '#7AB4D1',
        inputFocusBorderAlt: '#7AB4D1',
    },
    defaultFontStyle: {
        fontFamily,
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
    },
    effects: {
        roundedCorner2: '4px',
        roundedCorner4: '6px',
        roundedCorner6: '8px',
    },
    isInverted: true,
});
